import React, { useEffect, useState } from "react";
import { Alert } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";
import useFlash from "go-alert/AlertMessage";
import Header from "go-app/components/Header";
import handleError from "go-app/services/errors";
import handleException from "go-core/api/handleException";
import { LoadingContainer } from "go-core/components/Loading";
import { OrganizationApi } from "../../../../../../../../services/Api/types";
import { api } from "../../../../../../../../services/Security/api";

const PartnerLoansExternalNewPage = () => {
	const urlSearchParams = new URLSearchParams(window.location.search);
	const organizationId = urlSearchParams.get("organization_id");
	const redirect_uri = urlSearchParams.get("return_url");
	const { addFlash } = useFlash();
	const [organization, setOrganization] = useState<OrganizationApi | null | undefined>(undefined);
	const history = useHistory();
	const location = useLocation();
	const { t } = useTranslation("admin");

	useEffect(() => {
		checkOrganization();
	}, []);

	const checkOrganization = async () => {
		try {
			const org = await api.user().getOrganization(Number(organizationId), { include: "partners" });
			setOrganization({
				...org,
				sub_partner: org?.sub_partner,
				partner: org?.partner,
			});
		} catch (e) {
			const errors = handleException(e);
			if (errors[0].code === "organization_not_found" || errors[0].code === "access_forbidden") {
				setOrganization(null);
			} else {
				handleError.alert(e, addFlash);
			}
		}
	};

	if (organization && organization.partners.length) {
		history.push({
			pathname: `/partnership/${organization.partners[0]}/loans/new?${urlSearchParams}`,
			state: { org: organization, from: location.pathname },
		});
	}

	if ((organization || organization === null) && organization?.partners.length) {
		return (
			<div>
				<Header title={t("modules.loan.header.title")} />
				<div className={"content-preview"}>
					<Alert variant={"danger"}>
						{t("modules.partner.field.no_location_access.title")}&nbsp;
						{redirect_uri && <a href={redirect_uri}>{t("common.action.back", { ns: "lib" })}</a>}
					</Alert>
				</div>
			</div>
		);
	}

	return <LoadingContainer />;
};
export default PartnerLoansExternalNewPage;
